import {createContext, Dispatch, FC, Reducer, useReducer} from "react";
import {DynamicsCompany, IGroup} from "../types/ApiTypes";

const initialData = {
    groups: [],
    customers: []
};

interface State {
    groups: IGroup[],
    customers: DynamicsCompany[]
}

type Actions =
    {type: 'APPEND_GROUP', payload: IGroup}|
    {type: 'SET_GROUPS', payload: IGroup[]}|
    {type: 'REPLACE_GROUP', payload: IGroup}|
    {type: 'SET_CUSTOMERS', payload: DynamicsCompany[]}|
    {type: 'REMOVE_GROUP', payload: IGroup|string}

const GroupsReducer: Reducer<State, Actions> = (state,action) => {
    switch (action.type) {
        case "APPEND_GROUP": return {
            ...state,
            groups: [...state.groups, action.payload]
        }
        case "SET_GROUPS": return {
            ...state,
            groups: action.payload
        }
        case "REPLACE_GROUP": {
            const groups = state.groups.slice();
            let idx = groups.findIndex(x => x.requestId === action.payload.requestId);
            if(idx > -1) groups[idx] = {...groups[idx], ...action.payload};
            else groups.push(action.payload);
            return {
                ...state,
                groups: groups
            }
        }
        case "SET_CUSTOMERS": return {
            ...state,
            customers: action.payload
        }
        case "REMOVE_GROUP":
            let stateCopy = state.groups.concat();
            if(typeof action.payload === 'string') stateCopy = stateCopy.filter(x => x.requestId !== action.payload);
            else stateCopy = stateCopy.filter(x => x.requestId !== (action.payload as IGroup).requestId);
            return {
                ...state,
                groups: stateCopy
            }
    }
}

export const GroupsContext = createContext<{
    state: State,
    dispatch: Dispatch<Actions>
}>({
    state: initialData,
    dispatch: (payload: Actions) => {}
});

export const GroupsProvider: FC = ({children}) => {
    const [state,dispatch] = useReducer(GroupsReducer, initialData);
    return (
        <GroupsContext.Provider value={{
            state,
            dispatch
        }}>{children}</GroupsContext.Provider>
    )
}